import dayjs from 'dayjs';

const biblia_registros_store = {
  namespaced: true,
  state: () => ({
    biblia: null,
    list: [],
    sacsayhuamanColors: [],
    qoricanchaOptions: [
      {
        id: 1,
        label: 'Sí',
      },
      {
        id: 0,
        label: 'No',
      },
    ],
    servicio_tipos: [],
    agencias: [],
    hoteles: [],
    horas_recojo: [],
    idiomas: [],
    restaurantes: [],
    asistentes: [],
    estados: [
      { id: 1, label: 'Pendiente' },
      { id: 2, label: 'Confirmado' },
    ],
    lunchs: ['Firmar', 'Cupón', 'Lunch', 'No'],
  }),
  mutations: {
    load(
      state,
      {
        biblia,
        list,
        sacsayhuamanColors,
        servicio_tipos,
        agencias,
        hoteles,
        horas_recojo,
        idiomas,
        restaurantes,
        asistentes,
      }
    ) {
      state.biblia = biblia;
      state.list = list;
      state.sacsayhuamanColors = sacsayhuamanColors;
      state.servicio_tipos = servicio_tipos;
      state.agencias = agencias;
      state.hoteles = hoteles;
      state.horas_recojo = horas_recojo;
      state.idiomas = idiomas;
      state.restaurantes = restaurantes;
      state.asistentes = asistentes;
    },
    updateList(state, list) {
      state.list = list;
    },
  },
  getters: {
    hayNuevos(state) {
      return state.list.some((item) => item.isNew || item.isEdit);
    },
  },
  actions: {
    newItem({ commit, state }) {
      const list = [...state.list];

      list.unshift({
        idBibliaRegistro: new Date().getTime(),
        isNew: true,
        isEdit: false,

        tempAgencia: null,
        tempFile: '',
        tempNombre: '',
        tempTipo: '',
        tempPAX: '',
        tempCHD: '',
        tempIdioma: null,
        tempHotel: null,
        tempSacsayhuaman: null,
        tempQoricancha: null,
        tempHoraRecojo: '',
        tempIngresoBTG: '',
        tempIngresoCAT: '',
        tempIngresoQOR: '',
        tempAsistente: null,
        tempRecomendaciones: '',
        tempObservaciones: '',
        tempEstado: state.estados.find((item) => item.id == 2),
        tempEnlaceTren: '',
        tempRestaurante: null,
        tempLunch: null,
        tempRecojoPisac: false,
      });

      commit('updateList', list);
    },
    editItem({ commit, state }, id) {
      const newList = state.list.map((row) => {
        if (row.idBibliaRegistro == id) {
          return {
            ...row,
            isEdit: true,

            tempAgencia: state.agencias.find((item) => item.idAgencia == row.idAgencia) || null,
            tempFile: row.codigoAgencia || '',
            tempNombre: row.nombre,
            tempTipo:
              state.servicio_tipos.find((item) => item.idServicioTipo == row.idTipo) || null,
            tempPAX: row.nroAdultos || '',
            tempCHD: row.nroNinos || '',
            tempIdioma: state.idiomas.find((item) => item.idIdioma == row.idIdioma) || null,
            tempHotel: state.hoteles.find((item) => item.idHotel == row.idHotel) || null,

            tempSacsayhuaman:
              state.sacsayhuamanColors.find((item) => item.idSacsayhuaman == row.idSacsayhuaman) ||
              null,
            tempQoricancha: row.qoricancha
              ? state.qoricanchaOptions.find(
                  (item) => item.id == (row.qoricancha == 'Sí' ? 1 : 0)
                ) || null
              : null,

            tempHoraRecojo: row.horaRecojo ? dayjs(row.horaRecojo, 'HH:mm:ss').format('HH:mm') : '',
            tempIngresoBTG: row.ingresosBTG || '',
            tempIngresoCAT: row.ingresosCatedral || '',
            tempIngresoQOR: row.ingresosQoricancha || '',
            tempAsistente:
              state.asistentes.find((item) => item.idPersona == row.idAsistente) || null,
            tempRecomendaciones: row.recomendacionesGuia || '',
            tempObservaciones: row.observacion || '',
            tempEstado: state.estados.find((item) => item.id == row.idEstado) || null,
            tempEnlaceTren: row.enlaceTren ? dayjs(row.enlaceTren, 'HH:mm:ss').format('HH:mm') : '',
            tempRestaurante:
              state.restaurantes.find((item) => item.idRestaurante == row.idRestaurante) || null,
            tempLunch: row.lunch,
            tempRecojoPisac: row.recojoPisac == 'Sí' ? true : false,
          };
        }
        return row;
      });

      commit('updateList', newList);
    },
    removeItem({ commit, state }, id) {
      const list = state.list.filter((row) => row.idBibliaRegistro != id);
      commit('updateList', list);
    },
    saveItem({ commit, state }, { id, newId }) {
      const newList = state.list.map((row) => {
        if (row.idBibliaRegistro == id) {
          return {
            ...row,
            isNew: false,
            isEdit: false,

            idBibliaRegistro: newId,
            codigo: `${dayjs().format('YY')}BR${newId}`,
            agencia: row.tempAgencia?.nombre,
            idAgencia: row.tempAgencia?.idAgencia,
            codigoAgencia: row.tempFile,
            nombre: row.tempNombre,
            idTipo: row.tempTipo?.idServicioTipo,
            tipo: row.tempTipo?.sigla,
            nroAdultos: row.tempPAX,
            nroNinos: row.tempCHD,
            idIdioma: row.tempIdioma?.idIdioma,
            idioma: row.tempIdioma?.abreviatura,
            idHotel: row.tempHotel?.idHotel,
            hotel: row.tempHotel?.nombre || '',
            idSacsayhuaman: row.tempSacsayhuaman?.idSacsayhuaman,
            sacsayhuaman: row.tempSacsayhuaman?.nombre || '',
            qoricancha: row.tempQoricancha?.label || '',
            horaRecojo: row.tempHoraRecojo
              ? dayjs(row.tempHoraRecojo, 'HH:mm').format('HH:mm:ss')
              : '',
            ingresosBTG: row.tempIngresoBTG,
            ingresosCatedral: row.tempIngresoCAT,
            ingresosQoricancha: row.tempIngresoQOR,
            idAsistente: row.tempAsistente?.idPersona,
            asistente: row.tempAsistente?.nombre || '',
            recomendacionesGuia: row.tempRecomendaciones,
            observacion: row.tempObservaciones,
            idEstado: row.tempEstado?.id,
            estado: row.tempEstado?.label,
            enlaceTren: row.tempEnlaceTren
              ? dayjs(row.tempEnlaceTren, 'HH:mm').format('HH:mm:ss')
              : '',
            idRestaurante: row.tempRestaurante?.idRestaurante,
            restaurante: row.tempRestaurante?.nombre,
            lunch: row.tempLunch,
            recojoPisac: row.tempRecojoPisac ? 'Sí' : 'No',
          };
        }
        return row;
      });

      commit('updateList', newList);
    },
  },
};

export default biblia_registros_store;
